import {
  AvatarGroup as MuiAvatarGroup,
  AvatarGroupProps as MuiAvatarGroupProps,
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { avatarTheme } from './Avatar';

export const AvatarGroup: React.FC<MuiAvatarGroupProps> = ({ ...props }: MuiAvatarGroupProps) => {
  return (
    <ThemeProvider theme={avatarTheme}>
      <MuiAvatarGroup {...props} />
    </ThemeProvider>
  );
};
